module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-14-svgrepo-com.f1f54d6d.svg";